import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

// Files Import
import { content } from "../../../data";
import Copyrights from "../../Copyrights/Copyrights";
import SocialButton from "../../Buttons/SocialButton/SocialButton";
import StyledSmText from "../../../common/components/styledSmText/StyledSmText";
import StyledH6Heading from "../../../common/components/styledH6Heading/StyledH6Heading";

const Footer = () => {
  const location = useLocation();
  const is404Page = location.pathname === "/404";

  return (
    <div
      className={`w-full flex justify-center ${is404Page ? "bg-[#000]" : ""}`}
    >
      <div className="w-full lg:w-[80%] flex justify-center mt-10 footer-border">
        <div className="w-[95%] ">
          {/* Header LOGO */}
          <div className="flex justify-center pt-10 pb-5">
            <Link to="/">
              <img
                className="hidden md:flex"
                src="/assets/footer-golden-years.svg"
                alt="Footer Logo"
              
              />
              <img
                className="flex md:hidden h-[80px]"
                src="/assets/footer-logo-responsive.svg"
                alt="Footer Logo"
                height={250}
                width={250}
              />
            </Link>
          </div>

          {/* NavLinks */}
          <div className="flex flex-col lg:flex-row items-center text-center justify-between gap-4 pb-4">
            {content.Footer.map((item, index) => (
              <NavLink
                key={index}
                to={item.link}
                className="text-black hover:scale-x-105 transform transition"
              >
                <StyledH6Heading>{item.title}</StyledH6Heading>
              </NavLink>
            ))}
          </div>

          <hr className="border-b-2 border-black" />

          {/* CopyRight */}
          <div className="flex flex-col-reverse gap-1 lg:flex-row justify-between items-center text-black py-1">
            <div className="w-fit">
              <Copyrights />
            </div>
            <div className="w-fit">
              <SocialButton />
            </div>
            <div className="lg:w-[25%] xl:w-[20%] flex justify-end">
              <Link to={"disclaimer"} className="hover:underline">
                <StyledSmText>Disclaimer</StyledSmText>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
